export default __webpack_public_path__ + "static/qkAjQbAD-57188cba99f6d9d883b0caf919203b9a.jpeg";